import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const Header = styled.div`
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  margin: 15px;
  label {
    font-size: 14px;
    font-weight: 700;
    color: ${(props) => props.theme.colors.darkerblue};
  }
`;

export const Icon = styled.img`
  width: ${(props) => (props.size ? props.size : '20px')};
  height: ${(props) => (props.size ? props.size : '20px')};
  margin-left: auto;
  cursor: pointer;
`;

export const GraphContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 20px 0px 20px;
`;

export const TotalErros = styled.label`
  position: absolute;
  font-size: 8vh;
  color: ${(props) => props.theme.colors.red};
`;

export const DescriptionContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 4fr));
  column-gap: 10px;
  margin-bottom: 10px;
`;

export const Description = styled.div`
  ${(props) => props.selected && 'transform: scale(1.2); transition: 0.2s'};
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin: 6px 15px;
  z-index: 2;

  label {
    color: ${(props) => props.theme.colors.darkerblue};
    font-size: 70%;
    font-weight: bold;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Intensidade = styled.div`
  width: 13px;
  height: 13px;
  background: ${(props) => props.color};
  border-radius: 50%;
  margin: 0 10px;
`;
